<template>
  <div class="loginContainer">
    <div class="logo">
      <img v-if="logo" width="134" :src="logo" />
      <div v-if="logo">&nbsp;&nbsp;|&nbsp;</div>
      答题卡制作
    </div>
    <div class="content">
      <div class="header-box">
        <div class="title">账号登录</div>
        <div class="subtitle">欢迎登录答题卡工具</div>
        <div class="subtitle">
          <!-- 新版答题卡工具将提供更加完美的体验，支持众多风格和类型的题卡，满足您不同的需求 -->
        </div>
      </div>

      <el-form
        class="login-form"
        :model="loginForm"
        :rules="rules"
        label-position="top"
      >
        <div class="label">账号</div>
        <el-form-item prop="account">
          <el-input
            v-model="loginForm.account"
            placeholder="请输入手机号"
            autocomplete="off"
            ><img
              slot="prefix"
              class="prefix-img"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkCAYAAADo6zjiAAAAAXNSR0IArs4c6QAAA71JREFUWEe1mF1oXEUYhp93N40GiSjSqsXEIEqr+IO98Kex2bOhBEVLVZC2grV7Uv+xgjeCQl1RKIhFUdSLumfpjwpBUUqlamhztqK5UNT2oq0/VUKNVrTqRWIxTfZzZ8lCTNPdc87i3M77vfPMd2a+MzMiZlu+1Tonp9gA3AZcDJwJ/GkwJLHdG2FnPq9yVFtFFTpdpmiPYrwgaK0TNywjN9Svb6J4RwbIBrbR4JkopsBxxE1hTocb6SMB9Aa2tAyfNjKb1T8c5uhGsnpxkQAyRftIRl9MAEz0lXIabAqgb5stmJjkGBAJdtZgO0Jf9zQFkH3DbrUUu+LOflr/a+jrgqYAvMCeAp5LCABTdIT36afTxTdMayawgsBPCmCip5TTJ4kBvMDeB1YmBUDcEebkPOZsjTOQcAfMGG1d6GtrIgCvaF1mHBGkEmcADoW+rkgEkCnaChk7mxjchf4V+jo3EUDPFrs8leZgMwAGn5V8dScCcEHZwN4yWJMEwmBCYmWY04eJAVxgpmglGT1xIUysLeW0valCVAUI7CHBa3EA3Oxb0izcc6+ONw3Qt83Ompjka+DSqBCCTUO+nmykb1gHagbeFruINHuByxqZmrGx1K9nG+lcf2QAJ/aKdjPG7nrGZhwo9euaKIMnAejC+LEuAAyUfK36vwAWYxxqYD4Y+op8eIn3CQJ7qXICfqwBwGS5zHX71uurKFmIBNBdsPZ5KTZhPBLF1B1KJe4fWsd7TZ0JvaItFtxtsB7jwjkGd7M8ACwCbpjdb8a3grfTYmCPrzlL+ikZcBePqSlWG6wGrj3djA1+OKOFqz9eq/G7Bqz1tzH2AdfXydAw4mVGeCfMa7KmqwLk85YKO1iDeABYFjHNpTBHtpbiTMFelXg4Quyou9y0jfP67g36R7fssLNPTFR/uZkIwf+R1Gp9tmCLyuJgnHODwZfzTtKrTME2Szwed3CnL5dZ4la7V7RzMP6IW9iAzfICc4voqgQAv4c5FtQ+gReYu4a5xRin7XcAfwNtcaKmtbtCXytqcZnA3nQ7Jo5P9bzgBVb37lZnFzxf8vVErd8rWB7xdBwA4KQygY0KFsYMdPKjTLHUXTqWBTY/DZ9PvxfEsTrqAN4V3Bknaob2mMQrZjwIdMT1ELyoGwesrXWM24HlgiXAlZWrWEtcs4j6scrLyhcSg5T5YKhf+0+phNWqNs4lqTKdJroMOhHuN3w+cB4wv7J92g3aZ+776oKCE8CYiVEZvwh+LsN3iO8rlfVw7whHZj/f/Avz4UkM5qjEjAAAAABJRU5ErkJggg=="
          /></el-input>
        </el-form-item>
        <div class="label">密码</div>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.passWord"
            placeholder="请输入密码"
            autocomplete="off"
          >
            <img
              slot="prefix"
              class="prefix-img"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAYAAACaJFpUAAAAAXNSR0IArs4c6QAAApZJREFUWEftlz1oE2EYx3/PpRZEHcTFQQUHtYUirYIoiLm0UKiDi4vgR5M7wUlEQURcMjm4KLhJ76IVwcVJKEVpc0EEBakfILS6SK3QRRysCNL0kVyv6TW5JJd+LKW35X3/z//35v+8976cEOMxs9rCHk6jnEE4CuwMyqZR3iA8ZZJnXlZmG9lJI0HS0WMiuEBbA+2EGNj5tLyup6sLNB09i5ADNjVaWDA/i5L2bHlSS18T2O1qdxFeChgVxdMqfCqNiXIwFK8vU5gzDHrzaRmJgkYCewd1y79ZxoFdoaJvwGVzkqFsVubm3VVSDic1wX2UvSHtVGsLbS8uyJ9KaCTQzOkVlHsh8XgiwfGRfvkZteqeR7qjWOQV0F6eV656toQ9/KlooKvvgMNBsSYSdI70ix9jrccc0A41+LjQAoWxgiULHuWyKmAQ5+/yYpRhz5a+OJvGdHUIWNBqawvbKmOtAqYcPaDi928+AuFWPiO34wCTrt4UWNQK7V5Gyl6RkZo57UR5H+rFRc8WJw4wlVNLlUWt0OVl5EO4tuofRgAzni0P4wBNR9PBexvEswEE1l+kJwa0yzB4AOwLNkYC2BraJH+Bf3E2DdAKbA5pZ4Bi8PurAZck6eiECPtjGq5IpsoXMV3VFbk0WbwBjAqs1IKxYOJQrRunVtLNRvpLoC9vyduSYfeAHpkzGAa2x21lU0CFawVL7obNIy7ruuymgAb0jFoyGnZMOpoSYclYPWJTQIEbeUvuVACvi7BkbNWAwIwqpwq25EumZk5NlOcVJ9PqRRo4FTxLTB/oqgck424Y/8Zfxkmz/oGfEc75MSqPgY61jrQZ/yrtcnq4AWz4Hn6v+EpaUWQNin9IcFoMArvXkgRMIZz/D1QLMnT8KZLnAAAAAElFTkSuQmCC"
          /></el-input>
        </el-form-item>
        <el-button
          aria-disabled="false"
          type="primary"
          class="login-button"
          @click="loginClick"
          >登录</el-button
        >
      </el-form>
      <page-footer
        :link-list="footerLinks"
        :copyright="copyright"
      ></page-footer>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import account from '../services/account';
import PageFooter from '@/components/footer/PageFooter';
export default {
  name: 'Login',
  components: { PageFooter },
  data() {
    return {
      loginForm: {
        account: '',
        passWord: '',
      },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      footerLinks: [
        //页面底部链接，{link: '链接地址', name: '名称/显示文字', icon: '图标，支持 ant design vue 图标库'}
        { link: 'https://beian.miit.gov.cn/', name: process.env.VUE_APP_BEIAN },
        // {link: 'https://github.com/iczer/vue-antd-admin', icon: 'github'},
        // {link: 'https://ant.design', name: 'Ant Design'}
      ],
      copyright: `${process.env.VUE_APP_COPYRIGHT}`,
    };
  },
  mounted() {},
  computed: {
    logo() {
      return process.env.VUE_APP_LOGO ? require(process.env.VUE_APP_LOGO) : '';
    },
  },
  methods: {
    ...mapMutations('account', ['setUser', 'setToken']),
    loginClick() {
      account.Login(this.loginForm).then((res) => {
        const { user, token } = res.data;
        this.setUser(user);
        this.setToken(token);
        this.$router.push('/');
      });
    },
  },
};
</script>
<style scoped>
.loginContainer {
  min-height: 100%;
  width: 100%;
  background-image: url(../assets/images/login_left-f20a4737.png);
  background-repeat: no-repeat;
  background-size: 60% 100%;
  background-color: #fff;
  overflow: hidden;
}

.loginContainer .logo {
  position: relative;
  top: 29px;
  left: 39px;
  font-size: 23px;
  display: flex;
  align-items: center;
}

.loginContainer .content {
  width: 40%;
  float: right;
}

.loginContainer .header-box {
  width: 430px;
  margin: 22% auto -20px;
  padding-left: 10px;
}

.loginContainer .header-box .title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 40px;
  color: #444;
}

.loginContainer .header-box .title span {
  font-size: 40px;
  color: #1890ff;
  vertical-align: bottom;
  padding-right: 13px;
}

.loginContainer .header-box .subtitle {
  font-size: 12px;
  color: #666;
  margin-bottom: 3px;
}

.loginContainer .header-box .des {
  letter-spacing: 2px;
  font-size: 18px;
  color: #555;
}

.loginContainer .login-form {
  margin: 5% auto 0;
  width: 480px;
  padding: 35px 35px 30px;
  background-color: #fff !important;
  border-radius: 10px;
  overflow: hidden;
}

.loginContainer .header {
  margin-bottom: 25px;
}
.login-form .label {
  padding: 10px 0 16px;
  font-size: 14px;
  margin-bottom: -8px;
}
.loginContainer .header .title {
  font-size: 22px;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 25px;
  text-align: left;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
}

.loginContainer .header img {
  width: auto;
  height: 80px;
  display: block;
  margin: 0 auto;
}

.loginContainer .svg-container {
  padding: 6px 5px 6px 15px;
  color: #454545;
  vertical-align: middle;
  width: 30px;
  display: inline-block;
}

.loginContainer .show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.loginContainer .login-button {
  width: 100%;
  height: 42px;
  font-size: 14px;
  margin-top: 10%;
  border: 0;
  color: #fff;
  background-color: #1890ff;
}

.loginContainer .to_2 {
  width: 100%;
  height: 38px;
  font-size: 16px;
  margin-top: 20px;
  border: 0;
  margin-left: 0;
  color: #1890ff;
  background-color: #e6f7ff;
}

.loginContainer .to_2::hover {
  color: #1890ff;
  background-color: #e6f7ff;
}

.loginContainer .tips {
  margin-top: 10px;
  font-size: 14px;
  color: #bbb;
}

.prefix-img {
  width: 11px;
  height: 11px;
}
</style>
